export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5022.7cd71e1d.jpg";